import React, { useState, useRef, useEffect } from "react";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import DocumentManager from "../DocumentManager/DocumentManager";
import backIcon from "../../assets/back-button.png";
import loader from "../../assets/Images/Request_Property/Loader.gif";
import './EditPropertyModel.css';
import editIcon from "./../../assets/Images/edit (1).png";
import close from './../../assets/Images/Request_Property/close.png';
import { getDocumentPreviewUrl } from '../../utils/fileHelpers';

const EditPropertyModal = ({
    showEditModal,
    setShowEditModal,
    PropertyDetails,
    handleChange,
    SaleAggementloading,
    onOpenSaleAggrimentUpload,
    onEditSaleAggriment,
    SaleDeedUploadedloading,
    onDeleteSaleDeedUploaded,
    onOpenSaleDeedUploaded,
    onEditSaleDeedUploaded,
    handleSaleDeedUploaded,
    onDeleteSaleAgreement,
    handleSaleAggrementUpload,
    handleSubmitOfEditProperty,
    handleSubmitPropertyData,
    fileInputRefForSaleAggrement,
    fileInputRefForSaleDeedUploaded,
    page222
}) => {

    const [page, setPages] = useState(page222)
    const [errors, setErrors] = useState({});
    const [isplaySaveMessahes, setdisplaySaveMessahes] = useState(null);
    useEffect(() => {
        console.log(isplaySaveMessahes, 'isplaySaveMessahes')
    }, [])
    const [DateLoading, setDateLoading] = useState(null);
    const [DocumentsData, setDocumentsData] = useState([]);
    const handleNext = () => {

        console.log('ssss')
        const newErrors = {};
        const pincode = PropertyDetails.pincode;
        if (!pincode || !/^\d{6}$/.test(pincode)) {
            newErrors.pincode = "Pincode must be exactly 6 digits";
        }
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setTimeout(() => {
                setErrors({})
            }, 2000);
        } else {
            setdisplaySaveMessahes(true)
            setPages('page2');
        }
    };
    const restrictSubmitUntilDeclareDate = () => {
        if (DocumentsData?.date) {
            const datas = DocumentsData?.date?.filter((x) => !x.declare)
            console.log(datas, 'datas')
            if (datas?.length === 0) {
                return true
            } else {
                return false
            }

        } else {
            return true
        }

    }
    if (!showEditModal) return null;

    const formFields = [
        { label: "Pincode", name: "pincode", placeholder: "Enter Pincode" },
        { label: "Address", name: "address", placeholder: "Enter Address" },
        { label: "City", name: "city", placeholder: "Enter City" },
        { label: "State", name: "state", placeholder: "Enter State" },
        { label: "Sale Deed Submission Date", name: "saleDeedSubmissionDate", placeholder: "Sale Deed Submission Date" },
    ];

    return (
        <div className="editProperty-modal-overlay">
            <div className="editProperty-modal-content">
                <div className="edit-property-form">
                {/* Header */}
                <div className="ep-header d-flex align-items-center justify-content-between">
                    <h4>Edit Property</h4>
                    <span className="editProperty-close-modal" onClick={() => setShowEditModal(false)}>
                        &times;
                    </span>
                </div>

                <hr className="ep-hr" />

                {page === 'page1' ? (
                    <div>
                        <div className="left-form">
                            {/* Fields Grid */}
                            <div className="ep-fields-grid">
                                {formFields.map((field, i) => (
                                    <div className="form-group" key={i}>
                                        <label>{field.label}</label>
                                        <input
                                            type={field.name === 'saleDeedSubmissionDate' ? 'date' : "text"}
                                            name={field.name}
                                            value={PropertyDetails[field.name]}
                                            onChange={handleChange}
                                            placeholder={field.placeholder}
                                            disabled={field.name === 'saleDeedSubmissionDate'}
                                        />
                                        {errors?.[field.name] && (
                                            <span className="error-text">{errors[field.name]}</span>
                                        )}
                                    </div>
                                ))}
                                <div className="form-group">
                                    <label>Property Type</label>
                                    <select
                                        name="propertyType"
                                        value={PropertyDetails.propertyType}
                                        onChange={handleChange}
                                    >
                                        <option value="agriculture">Agriculture</option>
                                        <option value="general">General</option>
                                    </select>
                                </div>
                            </div>

                            <hr className="ep-hr" />

                            {/* Document Cards */}
                            <div className="ep-docs-row">
                                {/* Sale Agreement */}
                                <div className="ep-doc-card">
                                    <div className="ep-doc-card-label">Sale Agreement</div>
                                    {SaleAggementloading ? (
                                        <div className="loader-container">
                                            <img src={loader} alt="Loading..." width={24} />
                                            <p>Loading...</p>
                                        </div>
                                    ) : PropertyDetails.sale_Aggrement === "" ? (
                                        <button className="btn uploadButton" onClick={(e) => { e.stopPropagation(); onOpenSaleAggrimentUpload(); }}>
                                            Upload
                                        </button>
                                    ) : (
                                        <iframe
                                            src={getDocumentPreviewUrl(PropertyDetails.sale_Aggrement)}
                                            title="Sale Agreement Viewer"
                                        />
                                    )}
                                    <input
                                        type="file"
                                        ref={fileInputRefForSaleAggrement}
                                        style={{ display: "none" }}
                                        accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.csv,.svg"
                                        onChange={handleSaleAggrementUpload}
                                    />
                                </div>

                                {/* Sale Deed Document */}
                                {PropertyDetails.saleDeedUploaded && (
                                    <div className="ep-doc-card">
                                        <div className="ep-doc-card-label">Sale Deed Document</div>
                                        {SaleDeedUploadedloading ? (
                                            <div className="loader-container">
                                                <img src={loader} alt="Loading..." width={24} />
                                                <p>Loading...</p>
                                            </div>
                                        ) : PropertyDetails.saleDeedUploaded === "" ? (
                                            PropertyDetails.saledeedVerified === true && PropertyDetails.assignedCivilEngineer ? (
                                                <button
                                                    className="btn uploadButton"
                                                    onClick={(e) => { e.stopPropagation(); onOpenSaleDeedUploaded(); }}
                                                >
                                                    Upload
                                                </button>
                                            ) : null
                                        ) : (
                                            <>
                                                <div className="ep-doc-card-actions">
                                                    <img
                                                        onClick={(e) => { e.stopPropagation(); onEditSaleDeedUploaded(PropertyDetails.saleDeedUploaded); }}
                                                        src={editIcon}
                                                        className="editIcon"
                                                        alt="Edit"
                                                    />
                                                    <img
                                                        src={close}
                                                        className="close-btn-in-editProfile"
                                                        alt="Remove"
                                                        onClick={(e) => { e.stopPropagation(); onDeleteSaleDeedUploaded(PropertyDetails.saleDeedUploaded); }}
                                                    />
                                                </div>
                                                <iframe
                                                    src={getDocumentPreviewUrl(PropertyDetails.saleDeedUploaded)}
                                                    frameBorder="0"
                                                    title="Sale Deed Viewer"
                                                />
                                            </>
                                        )}
                                        <input
                                            type="file"
                                            accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.csv,.svg"
                                            ref={fileInputRefForSaleDeedUploaded}
                                            style={{ display: "none" }}
                                            onChange={handleSaleDeedUploaded}
                                        />
                                    </div>
                                )}

                                {/* Registration Document */}
                                {PropertyDetails.registrationDocument && (
                                    <div className="ep-doc-card">
                                        <div className="ep-doc-card-label">Registration Document</div>
                                        <iframe
                                            src={getDocumentPreviewUrl(PropertyDetails.registrationDocument)}
                                            frameBorder="0"
                                            title="Registration Document Viewer"
                                        />
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="ep-form-footer">
                            <button className="btn btnNext" onClick={() => handleNext()}>
                                Next →
                            </button>
                        </div>
                    </div>
                ) : (
                    <div>
                        <div className="document-section">
                            <DocumentManager
                                documentsData={PropertyDetails.documents[0]}
                                handleDocumentsUpdate={handleSubmitPropertyData}
                                setdisplaySaveMessahes={setdisplaySaveMessahes}
                                setDateLoading={setDateLoading}
                                setDocumentsData={setDocumentsData}
                            />
                        </div>
                        <div className="ep-form-footer">
                            <button className="btn btnprev" onClick={() => setPages('page1')}>
                                ← Back
                            </button>
                            <button
                                className="btn btnSubmit"
                                disabled={
                                    (PropertyDetails?.documents[0]?.categories && isplaySaveMessahes === false) ||
                                    DateLoading ||
                                    restrictSubmitUntilDeclareDate() === false
                                }
                                onClick={() => handleSubmitOfEditProperty()}
                            >
                                Save Changes
                            </button>
                        </div>
                    </div>
                )}
                </div>
            </div>
        </div>
    );
};

export default EditPropertyModal;
